import {AbstractControl, FormGroup, ValidatorFn} from "@angular/forms";
import {RENOVATION_MAP, RENOVATION_VALUE_MAP} from "./renovation-type";
import {SiteKeyEnum} from "../enums/site-key.enum";
import {RenovationKeyEnum} from "../enums/renovation-key.enum";

export const WebsiteRegex = /^(https?:\/\/(www\.)?|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/;
export const EmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const PasswordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#\$%\^&\*]).{8,}$/;
export const NotLetterRegex = /[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]/g;
export const LettersOnlyRegex = /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\s]+$/;
export const PhoneFrRegex = /^(?:\+33|0) ?[1-9]( ?\d{2}){4}$/;

export function MustMatch(controlName: string, matchingControlName: string) {
	return (formGroup: FormGroup) => {
		const control = formGroup.controls[controlName];
		const matchingControl = formGroup.controls[matchingControlName];

		if (matchingControl.errors && !matchingControl.errors.mustMatch) {
			// return if another validator has already found an error on the matchingControl
			return;
		}

		// set error on matchingControl if validation fails
		if (control.value !== matchingControl.value) {
			matchingControl.setErrors({mustMatch: true});
		} else {
			matchingControl.setErrors(null);
		}
	}
}

export function maxSimuValidator(max: number): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		if (control.value === null || control.value === '' || isNaN(control.value)) {
			return null;
		}
		return control.value > max ? {maxSimu: {value: control.value, maxAllowed: max}} : null;
	};
}

export function returnCompaniesForRenovOptions(code: RenovationKeyEnum): string[] {
	let list = Object.values(SiteKeyEnum) as string[]; // Get all companies by default

	if(code === RenovationKeyEnum.REFRESH) {
		list = [SiteKeyEnum.KOUTRAVO, SiteKeyEnum.LADRESSE, SiteKeyEnum.CADASTRE, SiteKeyEnum.KOUTRAVOFREE, SiteKeyEnum.LOISELETDAIGREMONT, SiteKeyEnum.SOLALRENOV]; //[9, 10, 13, 14, 21, 22]
	}
	return list;
}

export const specialCompaniesParcours: string[] = [SiteKeyEnum.SELOGER, SiteKeyEnum.LFIMMO, SiteKeyEnum.ARTHURIMMO, SiteKeyEnum.WEINVESTCLIENT];
export const specialCompaniesButtonPartners: string[] = [SiteKeyEnum.SELOGER];
export const specialHideFormData: string[] = [SiteKeyEnum.SELOGER];
export const specialHideWelcomePage: string[] = [SiteKeyEnum.SELOGER, SiteKeyEnum.INNOVIA];
export const specialHideTutoHelper: string[] = [SiteKeyEnum.INNOVIA];
export const specialRenovationTypesNrj: string[] = [RENOVATION_MAP.energie, RENOVATION_MAP.totale];
export const specialRenovationTypesNrjNb: number[] = [RENOVATION_VALUE_MAP.energie, RENOVATION_VALUE_MAP.totale];
export const specialHideSendButtonInSidebar: string[] = [SiteKeyEnum.LOISELETDAIGREMONT];
export const specialPathForNewRefs: string[] = [SiteKeyEnum.AGENCEPLUS, SiteKeyEnum.LALOUPEIMMO, SiteKeyEnum.KTVEXTERNAL];
export const denyAccessToMyInformation: string[] = [SiteKeyEnum.LADRESSE];
